import { FC, useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models, Report } from 'powerbi-client';
import { LoadingIndicator } from '../LoadingIndicator';
import { getAnalyticsToken } from './PowerBi.helpers';
import { asyncTimeout } from '../../../utils/helpers';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';

interface IProps {
  companyIds: number[];
  seasonId: number;
}

const PowerBi: FC<IProps> = ({ companyIds, seasonId }) => {
  const id = '1e63b118-e0bb-497a-9251-34aa85a7a51e';

  const embedUrl =
    'https://app.powerbi.com/reportEmbed?reportId=1e63b118-e0bb-497a-9251-34aa85a7a51e&groupId=4b671844-80b8-41d3-974b-cd139af77ead&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUUtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOnRydWUsImFuZ3VsYXJPbmx5UmVwb3J0RW1iZWQiOnRydWUsImNlcnRpZmllZFRlbGVtZXRyeUVtYmVkIjp0cnVlLCJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwic2tpcFpvbmVQYXRjaCI6dHJ1ZX19';
  // TODO: get token from api and periodicaly refresh token
  const [accessToken, setAccessToken] = useState<string | null>(null);

  const loadNewToken = async () => {
    const { token, expiresIn } = await getAnalyticsToken();
    setAccessToken(token);
    await asyncTimeout(expiresIn);
    await loadNewToken();
  };

  const { mobile } = useResponsiveQuery();

  const layoutType = mobile
    ? models.LayoutType.MobilePortrait
    : models.LayoutType.Master;

  useEffect(() => {
    loadNewToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!accessToken) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 35,
        }}
      >
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <PowerBIEmbed
      embedConfig={{
        type: 'report', // Supported types: report, dashboard, tile, visual and qna
        id,
        embedUrl,
        accessToken,
        tokenType: models.TokenType.Aad,
        filters: [
          {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: {
              table: 'company',
              column: 'id',
            },
            operator: 'In',
            values: companyIds,
            filterType: models.FilterType.Basic,
          },
          {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: {
              table: 'season',
              column: 'id',
            },
            operator: 'In',
            values: [seasonId],
            filterType: models.FilterType.Basic,
          },
        ],
        settings: {
          layoutType,

          panes: {
            filters: {
              expanded: false,
              visible: false,
            },
          },
        },
      }}
      eventHandlers={
        new Map([
          [
            'loaded',
            function () {
              console.log('Report loaded');
            },
          ],
          [
            'rendered',
            function () {
              console.log('Report rendered');
            },
          ],
          [
            'error',
            function (event) {
              if (event?.detail.errorCode) {
                // TODO: if 403 refresh token
                console.log('error code:', event?.detail.errorCode);
              }
              console.log('event details: ', event?.detail);
            },
          ],
        ])
      }
      cssClassName={'report-style-class'}
      getEmbeddedComponent={embeddedReport => {
        const report = embeddedReport as Report;
        console.log('report:', report);
      }}
    />
  );
};

export default PowerBi;
